export default function convertDateFormat(dateString: string) {
  const parts = dateString.split("-")

  const newDateString = parts[2] + "-" + parts[1] + "-" + parts[0]
  console.log(newDateString)
  return newDateString
}
